<tui-loader [loading]="isLoading()" [overlay]="true">
  <div class="content">
      @if (!isFeatureEnabled()) {
        <div class="locked-state" tuiNotification appearance="warning" size="m">
          Purchase <strong>Athlete categories &amp; grading</strong> to unlock six custom category
          slots.
          <a
            tuiButton
            appearance="outline"
            size="s"
            [routerLink]="['/features', 'custom_athlete_categories']"
          >
            View feature
          </a>
        </div>
      }

      @if (defaultLevels().length > 0) {
        <div class="categories-section">
          <p class="section-label">Default categories</p>
          <div class="category-rows">
            @for (level of defaultLevels(); track level.id) {
              <div class="category-row">
                <span class="category-name">{{ level.value }}</span>
                <span class="actions">
                  <button
                    tuiButton
                    appearance="action"
                    size="s"
                    iconStart="@tui.eye"
                    type="button"
                    (click)="viewLimits.emit(level.id)"
                  >
                    View limits
                  </button>
                  <button
                    tuiButton
                    appearance="action"
                    size="s"
                    iconStart="@tui.copy"
                    type="button"
                    [disabled]="!hasAvailableSlot()"
                    (click)="copyToNewCategory(level.value)"
                  >
                    Copy to new category
                  </button>
                </span>
              </div>
            }
          </div>
        </div>
      }

      @if (isFeatureEnabled()) {
        <div class="categories-section">
          <p class="section-label">Custom categories</p>

          <div class="category-rows">
            @if (isAdding()) {
              <div class="category-row editing">
                <tui-textfield tuiTextfieldSize="m" class="name-field">
                  <input
                    tuiInput
                    tuiAutoFocus
                    placeholder="Category name"
                    maxlength="30"
                    [formControl]="nameControl"
                    (keydown.enter)="saveNew()"
                    (keydown.escape)="cancel()"
                  />
                </tui-textfield>
                <span class="actions">
                  <button
                    tuiButton
                    appearance="flat-grayscale"
                    size="s"
                    type="button"
                    (click)="cancel()"
                  >
                    Cancel
                  </button>
                  <button
                    tuiButton
                    appearance="primary"
                    size="s"
                    iconStart="@tui.check"
                    type="button"
                    [disabled]="!canSave()"
                    (click)="saveNew()"
                  >
                    Save
                  </button>
                </span>
              </div>
            }

            @for (category of categories(); track category.id) {
              <div class="category-row" [class.editing]="editingId() === category.id">
                @if (editingId() === category.id) {
                  <tui-textfield tuiTextfieldSize="m" class="name-field">
                    <input
                      tuiInput
                      tuiAutoFocus
                      placeholder="Category name"
                      maxlength="30"
                      [formControl]="nameControl"
                      (keydown.enter)="save(category)"
                      (keydown.escape)="cancel()"
                    />
                  </tui-textfield>
                  <span class="actions actions--grouped">
                    <button
                      tuiButton
                      appearance="flat-grayscale"
                      size="s"
                      type="button"
                      (click)="cancel()"
                    >
                      Cancel
                    </button>
                    <button
                      tuiButton
                      appearance="primary"
                      size="s"
                      iconStart="@tui.check"
                      type="button"
                      [disabled]="!canSave()"
                      (click)="save(category)"
                    >
                      Save
                    </button>
                  </span>
                } @else {
                  <span class="category-name">{{ category.name }}</span>
                  <span class="actions">
                    <button
                      tuiButton
                      appearance="action"
                      size="s"
                      iconStart="@tui.eye"
                      type="button"
                      [disabled]="isBusy()"
                      (click)="viewLimits.emit(category.id)"
                    >
                      View limits
                    </button>
                    <button
                      tuiButton
                      appearance="flat"
                      size="s"
                      iconStart="@tui.pencil"
                      type="button"
                      [disabled]="isBusy()"
                      (click)="startEdit(category)"
                    >
                      Edit name
                    </button>
                    <button
                      tuiButton
                      appearance="flat-destructive"
                      size="s"
                      iconStart="@tui.trash-2"
                      type="button"
                      [disabled]="isBusy()"
                      (click)="onDelete(category)"
                    >
                      Delete
                    </button>
                  </span>
                }
              </div>
            } @empty {
              @if (!isAdding()) {
                <div tuiNotification appearance="info" size="m">
                  Use the <strong>Create category</strong> button to add a new athlete category.
                </div>
              }
            }
          </div>

          @if (!hasAvailableSlot() && categories().length > 0) {
            <div tuiNotification appearance="info" size="m">
              You've reached the limit of 6 custom athlete categories.
            </div>
          }
        </div>
      }
    </div>
</tui-loader>
